import { useEffect, useState } from 'react';

interface LogoProps {
  className?: string;
}

export function Logo({ className = '' }: LogoProps) {
  const [isDark, setIsDark] = useState(true);

  useEffect(() => {
    const checkTheme = () => {
      setIsDark(document.documentElement.classList.contains('dark'));
    };
    checkTheme();
    const observer = new MutationObserver(checkTheme);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  return (
    <a href="https://haikoinnovations.com" className={`flex items-center ${className}`} aria-label="Haiko Innovations">
      <img
        key={isDark ? 'dark' : 'light'}
        src={isDark ? '/logo-header-dark.png' : '/logo-header-light.png'}
        alt="Haiko Innovations"
        className="transition-opacity duration-200"
        style={{
          maxHeight: 'clamp(34px, 5.8vw, 48px)',
          maxWidth: 'clamp(175px, 17vw, 240px)',
          width: 'auto',
          height: 'auto',
        }}
      />
    </a>
  );
}
